/**
 * @description
 * Returns the path of a route based on the entity and id
 *
 * @param {string} entity
 * @param {string} id
 * @param {any} routes
 * @returns {string}
 *
 **/
export function getRouterPath(entity, id, routes) {
    for (const key in routes) {
        if (routes.hasOwnProperty(key)) {
            const route = routes[key];
            if (typeof route === 'string' && route.includes(`${entity}`)) {
                return route.replace(':id', id);
            }
            else if (typeof route === 'object') {
                // check for a key call searchRouteFor
                if (route.hasOwnProperty('searchRouteForEntity') && route.searchRouteForEntity === entity) {
                    // find the details route for the entity
                    for (const nestedKey in route) {
                        if (route.hasOwnProperty(nestedKey) && typeof route[nestedKey] === 'function') {
                            if (nestedKey === 'details') {
                                return route[nestedKey](id);
                            }
                        }
                    }
                }
                else {
                    for (const nestedKey in route) {
                        if (route.hasOwnProperty(nestedKey) && typeof route[nestedKey] === 'function') {
                            if (nestedKey === 'details' && route[nestedKey].toString().includes(`${entity}`)) {
                                return route[nestedKey](id);
                            }
                        }
                    }
                }
            }
        }
    }
    return '';
}
//# sourceMappingURL=get-router-path.js.map